/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import mean from './mean.js';

var variance = (function (data) {
  var dataMean = mean(data);
  var sq = data.map(function (n) {
    return Math.pow(n - dataMean, 2);
  });
  return mean(sq);
});

export { variance as default };
//# sourceMappingURL=variance.js.map
